import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   DeleteAlgovalues
export const DeleteAlgovalues = createSlice({
  name: "DeleteAlgovalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    DeleteAlgovalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_DeleteAlgovalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_DeleteAlgovalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    DeleteAlgovalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_DeleteAlgovalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchdeletealgo:(state)=>{
        state.switch = false
    }
  },
});
export default DeleteAlgovalues.reducer;
export const {
  DeleteAlgovalues_datagrid,
  success_api_call_DeleteAlgovalues_datagrid,
  failure_api_call_DeleteAlgovalues_datagrid,
  create_DeleteAlgovalues_datagrid_complete_api,
  DeleteAlgovalues_datagrid_is_success,false_switchdeletealgo
} = DeleteAlgovalues.actions;
